import { render, staticRenderFns } from "./OrantaPolicyCancel.vue?vue&type=template&id=b26e4c38&scoped=true&"
import script from "./OrantaPolicyCancel.vue?vue&type=script&lang=js&"
export * from "./OrantaPolicyCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26e4c38",
  null
  
)

export default component.exports